import { render, staticRenderFns } from "./AccountCreation.vue?vue&type=template&id=1907c53b&scoped=true"
import script from "./AccountCreation.vue?vue&type=script&lang=js"
export * from "./AccountCreation.vue?vue&type=script&lang=js"
import style0 from "./AccountCreation.vue?vue&type=style&index=0&id=1907c53b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1907c53b",
  null
  
)

export default component.exports